var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueCtkDateTimePicker',_vm._b({attrs:{"only-date":_vm.onlyDate,"locale":null,"behaviour":{
        time: {
            nearestIfDisabled: false
        }
    }},model:{value:(_vm.dateString),callback:function ($$v) {_vm.dateString=$$v},expression:"dateString"}},'VueCtkDateTimePicker',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }